import React from 'react';
import { Donor } from '../../models/Donor';

type RequestInfoProps = {
  donor: Donor;
}

const RequestInfo = (props: RequestInfoProps) => {
  const { donor } = props;

  return (
    <>
      <h2 className="main_title"><span>精子提供について</span></h2>
      <div className="prof_contents">
        <section>
          <div className="wrap">
            <dl className="graf_list">
              <dt>提供方法</dt>
              <dd>
                {
                  donor.request.methods.length > 0
                    ? <>{ donor.request.methodsText.join("・") }</>
                    : <>-</>
                }
              </dd>
              <dt>身元の開示</dt>
              <dd>{ donor.request.identityDisclosureText || '-' }</dd>
              <dt>出自を知る権利</dt>
              <dd>{ donor.request.originRightText || '-' }</dd>
            </dl>
            <dl className="graf_list">
              <dt>交通費・宿泊代</dt>
              <dd>{ donor.request.travelExpensesText || '-' }</dd>
              <dt>証明書の提示</dt>
              <dd>{ donor.request.certificatePresentationText || '-' }</dd>
            </dl>
          </div>
        </section>
      </div>
    </>
  );
}

export default RequestInfo;
